import * as c from 'common/constants';

/**
 * Is fetching
 */
export const isFetching = (state, id) => ({
  type: c.IS_FETCHING,
  state,
  id,
});

export default isFetching;



// WEBPACK FOOTER //
// ./src/common/actions/isFetching.js